import { render, staticRenderFns } from "./BaseFormWizard.vue?vue&type=template&id=1552cdbb"
import script from "./BaseFormWizard.vue?vue&type=script&lang=js"
export * from "./BaseFormWizard.vue?vue&type=script&lang=js"
import style0 from "./BaseFormWizard.vue?vue&type=style&index=0&id=1552cdbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports